// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__FG55F","obliqueLineWrap":"membershipbadge_obliqueLineWrap__37XTQ","obliqueLine":"membershipbadge_obliqueLine__3NoET"};